export default {
  clientid: 'f3af7518-ae07-44cd-b79f-3f0f2bc5f5fe',
  authority: 'https://smacatastrov2.b2clogin.com/tfp/smacatastrov2.onmicrosoft.com/B2C_1_signinflow' 
  //clientid: '8f8fb83a-cad9-46b9-bceb-1c4bb4dd7f50',
  //authority: 'https://catastrosmagob.b2clogin.com/tfp/catastrosmagob.onmicrosoft.com/B2C_1_signinflow' 
} 


// WEBPACK FOOTER //
// ./src/config/index.js